let rest1 = require('../asset/images/car_state_direction/rest-1-01.png')
let rest2 = require('../asset/images/car_state_direction/rest-2-01.png')
let rest3 = require('../asset/images/car_state_direction/rest-3-01.png')
let rest4 = require('../asset/images/car_state_direction/rest-4-01.png')
let rest5 = require('../asset/images/car_state_direction/rest-5-01.png')
let rest6 = require('../asset/images/car_state_direction/rest-6-01.png')
let rest7 = require('../asset/images/car_state_direction/rest-7-01.png')
let rest8 = require('../asset/images/car_state_direction/rest-8-01.png')

let empty1 = require('../asset/images/car_state_direction/empty-1-01.png')
let empty2 = require('../asset/images/car_state_direction/empty-2-01.png')
let empty3 = require('../asset/images/car_state_direction/empty-3-01.png')
let empty4 = require('../asset/images/car_state_direction/empty-4-01.png')
let empty5 = require('../asset/images/car_state_direction/empty-5-01.png')
let empty6 = require('../asset/images/car_state_direction/empty-6-01.png')
let empty7 = require('../asset/images/car_state_direction/empty-7-01.png')
let empty8 = require('../asset/images/car_state_direction/empty-8-01.png')

let hail1 = require('../asset/images/car_state_direction/hail-1-01.png')
let hail2 = require('../asset/images/car_state_direction/hail-2-01.png')
let hail3 = require('../asset/images/car_state_direction/hail-3-01.png')
let hail4 = require('../asset/images/car_state_direction/hail-4-01.png')
let hail5 = require('../asset/images/car_state_direction/hail-5-01.png')
let hail6 = require('../asset/images/car_state_direction/hail-6-01.png')
let hail7 = require('../asset/images/car_state_direction/hail-7-01.png')
let hail8 = require('../asset/images/car_state_direction/hail-8-01.png')


let take1 = require('../asset/images/car_state_direction/take-1-01.png')
let take2 = require('../asset/images/car_state_direction/take-2-01.png')
let take3 = require('../asset/images/car_state_direction/take-3-01.png')
let take4 = require('../asset/images/car_state_direction/take-4-01.png')
let take5 = require('../asset/images/car_state_direction/take-5-01.png')
let take6 = require('../asset/images/car_state_direction/take-6-01.png')
let take7 = require('../asset/images/car_state_direction/take-7-01.png')
let take8 = require('../asset/images/car_state_direction/take-8-01.png')

let scheduled1 = require('../asset/images/car_state_direction/scheduled-1-01.png')
let scheduled2 = require('../asset/images/car_state_direction/scheduled-2-01.png')
let scheduled3 = require('../asset/images/car_state_direction/scheduled-3-01.png')
let scheduled4 = require('../asset/images/car_state_direction/scheduled-4-01.png')
let scheduled5 = require('../asset/images/car_state_direction/scheduled-5-01.png')
let scheduled6 = require('../asset/images/car_state_direction/scheduled-6-01.png')
let scheduled7 = require('../asset/images/car_state_direction/scheduled-7-01.png')
let scheduled8 = require('../asset/images/car_state_direction/scheduled-8-01.png')

var img_vacant = require('../asset/images/driver-status/map/taxi.png')
var img_logout = require('../asset/images/driver-status/map/logout.png')
var img_suspension = require('../asset/images/driver-status/ban.png')
var img_rest = require('../asset/images/driver-status/map/rest.png')
var img_dispatched = require('../asset/images/driver-status/map/hailing.png')
var img_shift = require('../asset/images/driver-status/map/shift.png')
var img_disappearance = require('../asset/images/driver-status/map/interrupt.png')
var img_hired = require('../asset/images/driver-status/map/take_passenger.png')
var img_on_marker = require('../asset/images/onMarker.png')
var img_off_marker = require('../asset/images/offMarker.png')

function responseOnMarker(){
  return {img : img_on_marker}
}

function responseOffMarker(){
  return {img : img_off_marker}
}

function checkCarDirectionOutputImage(degrees, state) {

  switch (state) {
    case 0:
      let restImage
      // 北
      if(degrees === 200){
        restImage = rest7
      }
      if( degrees >= 0  && degrees <= 10){
        restImage = rest1
      }
      // 東北
      if(degrees <= 80 && degrees > 10){
        restImage = rest8
      }
      //東
      if(degrees <= 100 && degrees > 80){
        restImage = rest7
      }
      // 東南
      if(degrees <= 170 && degrees > 100){
        restImage = rest8
      }
      //南
      if( degrees > 170 && degrees <= 180){
        restImage = rest5
      }
      //北(負值)
      if(degrees >= -10  && degrees <= 0){
        restImage = rest1
      }
      // 西北
      if( degrees >= -80 && degrees < -10){
        restImage = rest2
      }
      //西
      if(degrees >= -100 && degrees < -80){
        restImage = rest3
      }
      // 西南
      if(degrees >= -170 && degrees < -100){
        restImage = rest4
      }
      //南(負值)
      if(degrees < -170 && degrees >= -180){
        restImage = rest5
      }
      return {
        name:'休息中',
        img:restImage
      }
    break;
    case 1:
      let emptyImage

      if(degrees === 200){
        emptyImage = empty7
      }
      // 北
      if(degrees >= 0  && degrees <= 10){
        emptyImage = empty1
      }
      // 東北
      if(degrees <= 80 && degrees > 10){
        emptyImage = empty8
      }
      //東
      if(degrees <= 100 && degrees > 80){
        emptyImage = empty7
      }
      // 東南
      if(degrees <= 170 && degrees > 100){
        emptyImage = empty8
      }
      //南
      if( degrees > 170 && degrees <= 180){
        emptyImage = empty5
      }
      //北(負值)
      if(degrees >= -10  && degrees <= 0){
        emptyImage = empty1
      }
      // 西北
      if( degrees >= -80 && degrees < -10){
        emptyImage = empty2
      }
      //西
      if(degrees >= -100 && degrees < -80){
        emptyImage = empty3
      }
      // 西南
      if(degrees >= -170 && degrees < -100){
        emptyImage = empty4
      }
      //南(負值)
      if(degrees < -170 && degrees >= -180){
        emptyImage = empty5
      }
      return {
        name:'空車',
        img:emptyImage
      }
    break;
    case 2:
        let hailImage
        if(degrees === 200){
          hailImage = hail7
        }
        // 北
        if(degrees >= 0  && degrees <= 10){
          hailImage = hail1
        }
        // 東北
        if(degrees <= 80 && degrees > 10){
          hailImage = hail8
        }
        //東
        if(degrees <= 100 && degrees > 80){
          hailImage = hail7
        }
        // 東南
        if(degrees <= 170 && degrees > 100){
          hailImage = hail8
        }
        //南
        if( degrees > 170 && degrees <= 180){
          hailImage = hail5
        }
        //北(負值)
        if(degrees >= -10  && degrees <= 0){
          hailImage = hail1
        }
        // 西北
        if( degrees >= -80 && degrees < -10){
          hailImage = hail2
        }
        //西
        if(degrees >= -100 && degrees < -80){
          hailImage = hail3
        }
        // 西南
        if(degrees >= -170 && degrees < -100){
          hailImage = hail4
        }
        //南(負值)
        if(degrees < -170 && degrees >= -180){
          hailImage = hail5
        }
      return {
        name:'派遣中',
        img:hailImage
      }
    break;
    case 3:
        let takeImage
        if(degrees === 200){
          takeImage = take7
        }
        // 北
        if(degrees >= 0  && degrees <= 10){
          takeImage = take1
        }
        // 東北
        if(degrees <= 80 && degrees > 10){
          takeImage = take8
        }
        //東
        if(degrees <= 100 && degrees > 80){
          takeImage = take7
        }
        // 東南
        if(degrees <= 170 && degrees > 100){
          takeImage = take8
        }
        //南
        if( degrees > 170 && degrees <= 180){
          takeImage = take5
        }
        //北(負值)
        if(degrees >= -10  && degrees <= 0){
          takeImage = take1
        }
        // 西北
        if( degrees >= -80 && degrees < -10){
          takeImage = take2
        }
        //西
        if(degrees >= -100 && degrees < -80){
          takeImage = take3
        }
        // 西南
        if(degrees >= -170 && degrees < -100){
          takeImage = take4
        }
        //南(負值)
        if(degrees < -170 && degrees >= -180){
          takeImage = take5
        }
      return {
        name:'載客中',
        img:takeImage
      }
    break;
    case 4:
        let scheduledImage
        if(degrees === 200){
          scheduledImage = scheduled7
        }
        // 北
        if(degrees >= 0  && degrees <= 10){
          scheduledImage = scheduled1
        }
        // 東北
        if(degrees <= 80 && degrees > 10){
          scheduledImage = scheduled8
        }
        //東
        if(degrees <= 100 && degrees > 80){
          scheduledImage = scheduled7
        }
        // 東南
        if(degrees <= 170 && degrees > 100){
          scheduledImage = scheduled8
        }
        //南
        if( degrees > 170 && degrees <= 180){
          scheduledImage = scheduled5
        }
        //北(負值)
        if(degrees >= -10  && degrees <= 0){
          scheduledImage = scheduled1
        }
        // 西北
        if( degrees >= -80 && degrees < -10){
          scheduledImage = scheduled2
        }
        //西
        if(degrees >= -100 && degrees < -80){
          scheduledImage = scheduled3
        }
        // 西南
        if(degrees >= -170 && degrees < -100){
          scheduledImage = scheduled4
        }
        //南(負值)
        if(degrees < -170 && degrees >= -180){
          scheduledImage = scheduled5
        }
      return {
        name:'排班車',
        img:scheduledImage
      }
    break;
    case 5:
      return {
        name:'登出',
        img:img_logout
      }
    break;
    case 6:
      return {
        name:'失聯',
        img:img_disappearance
      }
    break;
    case 7:
      return {
        name:'停權車',
        img:img_suspension
      }
    case -1:
      return {
        name:'失聯',
        img:img_disappearance
      }
    break;
    default:
  }

}

export default {
  checkCarDirectionOutputImage,
  responseOnMarker,
  responseOffMarker
}



// WEBPACK FOOTER //
// ./src/utilities/checkCarDirection.js